import { FC } from "react";
import { IoMdCheckmark } from "react-icons/io";

import { JudgeBasicSectionData } from 'src/dtos/applicationData'
import { JudgeRenewalBasicSectionData } from "src/dtos/renewalData";
import { SectionArticlesTitle } from "./styles";
import { TbFileCheck } from 'react-icons/tb'

interface JudgeBasicSectionProps {
  basicSection?: JudgeBasicSectionData
  isComplete: boolean
  isRenewal?: boolean
  renewalBasicSection?: JudgeRenewalBasicSectionData
}

const JudgeBasicSection: FC<JudgeBasicSectionProps> = ({ basicSection, isComplete, isRenewal, renewalBasicSection }) => {
  return (
    <section>
      <header>
        <h4>Judge</h4>
        {isComplete ? (
          <h6><IoMdCheckmark /> Complete</h6>
        ) : null}
      </header>
      <SectionArticlesTitle>BASIC INFORMATION</SectionArticlesTitle>
      <article>
        <strong>Name</strong>
        <span>{[basicSection?.firstName, basicSection?.lastName].join(' ') ?? 'N/A'}</span>
      </article>
      <article>
        <strong>Contact Information</strong>
        {!basicSection?.contactInfo?.isSameAsJudge ?
          <span>{[basicSection?.contactInfo?.firstName, basicSection?.contactInfo?.lastName].join(' ') ?? 'N/A'}</span>
          : null}
        <span>{basicSection?.contactInfo?.phoneNumber ?? 'N/A'}</span>
        <span>{basicSection?.contactInfo?.emailAddress ?? ''}</span>
        <span>{basicSection?.contactInfo?.faxNumber ?? ''}</span>
      </article>
      <article>
        <strong>Principal Office Address</strong>
        <span>{basicSection?.principalOfficeAddress?.formattedAddress ?? 'N/A'}</span>
        <span>{basicSection?.principalOfficeAddress?.suiteNumber ?? ''}</span>
      </article>
      {basicSection?.hasMailingAddress ? (
        <article>
          <strong>Mailing Address</strong>
          <span>{basicSection?.mailingAddress?.formattedAddress}</span>
          <span>{basicSection?.mailingAddress?.suiteNumber}</span>
        </article>
      ) : null}
      {basicSection?.hasBillingAddress ? (
        <article>
          <strong>Billing Address</strong>
          <span>{basicSection?.billingAddress?.formattedAddress}</span>
          <span>{basicSection?.billingAddress?.suiteNumber}</span>
        </article>
      ) : null}
      { isRenewal ?
      <article>
        <strong>County of the court over which the applicant presides</strong>
        <span>{renewalBasicSection?.presidingCounty ?? basicSection?.presidingCounty}</span>
      </article> 
      :
      <article>
        <strong>County of the court over which the applicant presides</strong>
        <span>{basicSection?.presidingCounty ?? 'N/A'}</span>
      </article>
      }
      {!isRenewal ? (
        <>
          <article>
            <strong>Court over which applicant presides</strong>
            <span>{basicSection?.residingCourt ?? 'N/A'}</span>
          </article>
          <article>
            <strong>Number of years you have presided over this court</strong>
            <span>{basicSection?.yearsPresidingCourt ?? 'N/A'}</span>
          </article>
          <article>
            <strong>Number of years of overall judicial experience</strong>
            <span>{basicSection?.yearsOverallExperience ?? 'N/A'}</span>
          </article>
          <SectionArticlesTitle>TEXAS BAR INFORMATION</SectionArticlesTitle>
          <article>
            <strong>Bar Card Number</strong>
            <span>{basicSection?.barCardNumber}</span>
          </article>
          <article>
            <strong>Date admitted to Texas Bar</strong>
            <span>{basicSection?.dateAdmittedTexasBar}</span>
          </article>
        </>
      ) : null}
      <SectionArticlesTitle>REVIEW</SectionArticlesTitle>
      {isRenewal ? (
        <>
          <article>
            <strong>Notes</strong>
            <span>{renewalBasicSection?.reviewData?.note ?? 'N/A'}</span>
          </article>
          <article>
            <strong>Files</strong>
            {!!renewalBasicSection?.reviewData?.files && renewalBasicSection?.reviewData?.files.length > 0 ? 
              renewalBasicSection?.reviewData?.files.map(file => (
                <span key={file?.id} className="icon"><TbFileCheck /> {file?.fileName ?? "N/A"}</span>
              )) : (
                <span>N/A</span>
              )}
          </article>
        </>
      ) : (
        <>
          <article>
            <strong>Notes</strong>
            <span>{basicSection?.review?.note ?? 'N/A'}</span>
          </article>
          <article>
            <strong>Files</strong>
            {!!basicSection?.review?.files && basicSection?.review?.files.length > 0 ? 
              basicSection?.review?.files.map(file => (
                <span key={file?.id} className="icon"><TbFileCheck /> {file?.fileName ?? "N/A"}</span>
              )) : (
                <span>N/A</span>
              )}
          </article>
        </>
      )}
    </section>
  )
}

export default JudgeBasicSection